import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlaylistAddCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"playlist_add_circle"}/>
}
